if (!customElements.get('promotion-drawer')) {
  customElements.define('promotion-drawer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.panel = this.querySelector('.promotion-drawer__panel');
      this.tab = this.querySelector('.promotion-drawer__tab');
      if (!this.panel || !this.tab) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const designMode = this.dataset.designMode === 'true';
      this.selectCampaign(designMode);
      this.campaignName = this.querySelector('.promotion-drawer__heading')?.textContent.trim() || 'Polecamy';
      this.storageKey = `klich-promotion-seen:${this.dataset.campaignSet || this.dataset.campaign}`;
      this.tab.setAttribute('aria-label', `Pokaż reklamę: ${this.campaignName}`);
      this.tab.addEventListener('click', () => this.setOpen(!this.classList.contains('is-open')), options);
      this.querySelectorAll('.promotion-drawer__cta, .promotion-drawer__media').forEach((link) => {
        link.addEventListener('click', () => this.remember(), options);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-open') && !this.hasBlockingSurface()) {
          this.setOpen(false);
        }
      }, options);
      this.hidden = false;
      let seen = false;
      try { seen = sessionStorage.getItem(this.storageKey) === 'true'; } catch (_) { /* Storage can be disabled. */ }
      // Small screens start with the tab so the offer never obscures the shop unexpectedly.
      if (designMode || (!seen && window.matchMedia('(min-width: 750px)').matches)) {
        this.timer = window.setTimeout(() => {
          if (!this.hasBlockingSurface() && !document.hidden) this.setOpen(true);
        }, designMode ? 450 : Number(this.dataset.delay) || 4000);
      }
    }

    selectCampaign(designMode) {
      // Keep the complete card together: copy, photograph and destination never mix.
      if (!this.defaultContent) {
        this.defaultCampaign = this.dataset.campaign;
        this.defaultContent = document.createElement('template');
        this.defaultContent.content.append(...Array.from(this.panel.childNodes, (node) => node.cloneNode(true)));
      }
      const templates = Array.from(this.querySelectorAll('template[data-promotion-campaign]'));
      const campaigns = [this.defaultCampaign, ...templates.map((template) => template.dataset.promotionCampaign)];
      const selectionKey = `klich-promotion-choice:${this.dataset.campaignSet || this.defaultCampaign}`;
      let selected = this.defaultCampaign;

      if (designMode) {
        if (campaigns.includes(this.dataset.preview)) selected = this.dataset.preview;
      } else if (this.dataset.rotate !== 'false') {
        try { selected = sessionStorage.getItem(selectionKey); } catch (_) { selected = null; }
        if (!campaigns.includes(selected)) {
          selected = campaigns[Math.floor(Math.random() * campaigns.length)];
          try { sessionStorage.setItem(selectionKey, selected); } catch (_) { /* Random selection still works without storage. */ }
        }
      }

      const template = templates.find((item) => item.dataset.promotionCampaign === selected) || this.defaultContent;
      this.panel.replaceChildren(template.content.cloneNode(true));
      this.dataset.campaign = selected;
    }

    hasBlockingSurface() {
      return Boolean(document.querySelector('dialog[open], cart-drawer.active, .menu-drawer-container[open], details-modal details[open], newsletter-popup.is-visible')) ||
        document.body.classList.contains('cart-drawer-open') || document.body.style.overflow === 'hidden';
    }

    remember() {
      if (this.dataset.designMode === 'true') return;
      try { sessionStorage.setItem(this.storageKey, 'true'); } catch (_) { /* Manual controls remain available. */ }
    }

    setOpen(open) {
      window.clearTimeout(this.timer);
      if (!open && this.panel.contains(document.activeElement)) this.tab.focus({ preventScroll: true });
      this.classList.toggle('is-open', open);
      this.panel.inert = !open;
      this.panel.setAttribute('aria-hidden', String(!open));
      this.tab.setAttribute('aria-expanded', String(open));
      this.tab.setAttribute('aria-label', `${open ? 'Zwiń' : 'Pokaż'} reklamę: ${this.campaignName}`);
      this.remember();
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}
